import { ButtonUnstyled } from '@emico-react/buttons'
import { libraryTheme } from '@emico-utils/library-theming'
import { overrideOptional } from '@emico-utils/overrides'
import styled from '@emotion/styled'

const Dots = styled.div`
  display: flex;
`

export const Dot = overrideOptional(styled(ButtonUnstyled, {
  shouldForwardProp: (prop) => !['isActive'].includes(prop.toString()),
})<{ isActive: boolean }>`
  width: 20px;
  height: 4px;
  margin-left: 4px;
  background-color: ${libraryTheme.accentColor('component-slider-dot-color')};
  opacity: ${({ isActive }) => (isActive ? 0.8 : 0.2)};

  &:first-of-type {
    margin-left: 0;
  }
`)

const Hidden = styled.span`
  display: none;
`

interface Props {
  slides: number
  currentSlide: number
  onDotClick(index: number): void
}

export const SliderDots = overrideOptional(
  ({ slides, currentSlide, onDotClick, ...other }: Props) => {
    const dots = [...Array(slides).keys()]

    return (
      <Dots {...other}>
        {dots.map((dot) => (
          <Dot
            key={dot}
            isActive={currentSlide === dot}
            onPress={() => onDotClick(dot)}
          >
            <Hidden>{dot}</Hidden>
          </Dot>
        ))}
      </Dots>
    )
  },
)
